import {Box} from "@mui/system";
import styles from "../../../../Vote/voteMainStyles";
import ViewInSource from "../../../../Vote/Sections/FooterSection/ViewInSource";
import MessageActionMenu from "./MessageActionMenu/MessageActionMenu";

export default function MessageDetailsFooterSection({ isScrollComplete }) {

    return (
        <Box sx={styles.footerContainer}>
            <ViewInSource />
            <MessageActionMenu isScrollComplete={isScrollComplete} />
        </Box>
    )
}